// @flow
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { tripica } from '../../api';
import { setPromoProducts } from './actions';
import type { FetchPromoProductsRequestActionType } from './types';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchPromoProductsRequestSaga(action: FetchPromoProductsRequestActionType): Generator<*, *, *> {
  try {
    const catalog = yield call([tripica, 'getCatalog']);
    const promoProducts = yield call([tripica, 'getPromoProducts'], catalog.allBonus);
    yield put(setPromoProducts(promoProducts));
  } catch (error) {
    WizzeeLog.warn('[saga] fetchPromoProductsRequestSaga', error);
  }
}

export function* saga(): Generator<*, *, *> {
  yield all([takeLatest('FETCH_PROMO_PRODUCTS_REQUEST', fetchPromoProductsRequestSaga)]);
}
